<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
    <g transform="translate(-369.25 -376.25)">
      <circle class="a" cx="10" cy="10" r="10" transform="translate(370 377)"/>
      <line class="b" y1="4" transform="translate(380 387)"/>
      <line class="b" transform="translate(380 383)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "InfoIcon"
}
</script>

<style scoped>
.a, .b {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.a {
  stroke-width: 1.5px;
}

.b {
  stroke-width: 2px;
}
</style>
